var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adsense-placeholder"},[(_vm.loaded)?_c('Adsense',{attrs:{"data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-format":_vm.dataAdFormat,"data-full-width-responsive":_vm.dataFullWidthResponsive}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }